import {
    buttonClassName,
    imageClassName,
    labelClassName,
    pxArrayToRem,
    type StyleRule,
} from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { pxToRem } from '@fluentui/react-northstar';

export const APConnectbannerContainer: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.white['100A'],
    background: theme.siteVariables.colors.charcoal['000'],
    paddingTop: pxToRem(42, 1),
    paddingLeft: pxToRem(18, 1),
    marginBottom: pxToRem(-36, 1),
    overflow: 'hidden',

    [theme.screen.tablet]: {
        padding: 0,
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: pxToRem(10, 1),
        marginBottom: pxToRem(-47, 1),
    },
});
export const ConnectBannerLeft: StyleRule = ({ theme }) => ({
    zIndex: theme.siteVariables.zIndexes.foreground,
    position: 'relative',
    [theme.screen.tablet]: {
        marginBottom: 0,
        paddingTop: pxToRem(42, 1),
        paddingBottom: pxToRem(49, 1),
        paddingLeft: pxToRem(49, 1),
    },
});
export const BannerTitle: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Heading.Medium65,
    fontSize: pxToRem(19, 1),
    marginBottom: pxToRem(17, 1),
    textTransform: 'uppercase',
    lineHeight: '108%',
    paddingLeft: pxToRem(1, 1),
    letterSpacing: pxToRem(0.7, 1),
    [theme.screen.tablet]: {
        letterSpacing: 0,
        fontSize: pxToRem(31, 1),
        marginBottom: pxToRem(32, 1),
        width: pxToRem(440, 1),
        lineHeight: '104%',
    },
});
export const BannerDescription: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(26, 1),
    width: pxToRem(350, 1),
    fontSize: pxToRem(14, 1),
    lineHeight: '124%',
    letterSpacing: 0,
    wordSpacing: 0,
    [theme.screen.tablet]: {
        marginBottom: pxToRem(41, 1),
        width: pxToRem(430, 1),
        fontSize: pxToRem(16, 1),
        lineHeight: '130%',
    },
});

export const RightSection: StyleRule = ({ theme }) => ({
    overflow: 'hidden',
    zIndex: theme.siteVariables.zIndexes.background,
    position: 'relative',
    top: pxToRem(-70, 1),
    marginBottom: pxToRem(-70, 1),
    left: pxToRem(29, 1),
    display: 'flex',
    width: 'auto',
    minHeight: pxToRem(121, 1),

    [`& .${imageClassName}`]: {
        width: pxToRem(491, 1),
        alignItems: 'flex-start',
        background: 'transparent',
        position: 'absolute',
        opacity: 0.1,
    },
    [theme.screen.tablet]: {
        width: pxToRem(852, 1),
        left: pxToRem(126, 1),
        top: 'unset',
        margin: pxArrayToRem([18, 0]),
        [`& .${imageClassName}`]: {
            opacity: 0.45,
            width: pxToRem(852, 1),
            height: pxToRem(281, 1),
        },
    },
});

export const TypeformButton: StyleRule = ({ theme }) => ({
    [`&.${buttonClassName}`]: {
        ...theme.siteVariables.textStyles.Text.Medium65,
        borderRadius: pxToRem(4, 1),
        background: theme.siteVariables.colors.white['FFF'],
        color: theme.siteVariables.colors.charcoal['000'],
        padding: pxArrayToRem([10, 40.5]),
        paddingRight: pxToRem(36, 1),
        border: 'none',

        [`& span`]: {
            marginLeft: pxToRem(3, 1),
        },
        [`& .${labelClassName}`]: {
            color: theme.siteVariables.colors.charcoal['000'],
            fontSize: pxToRem(20, 1),
            wordSpacing: 0,
            letterSpacing: pxToRem(0.2, 1),
            lineHeight: pxToRem(36, 1),
        },

        [`& .${svgIconClassName}`]: {
            width: pxToRem(16, 1),
            height: pxToRem(16, 1),
        },

        [`:hover`]: {
            background: theme.siteVariables.colors.white['FFF'],
            color: theme.siteVariables.colors.charcoal['000'],
            [`& .${labelClassName}`]: {
                color: theme.siteVariables.colors.charcoal['000'],
            },
        },

        [theme.screen.tablet]: {
            borderRadius: pxToRem(2, 1),
            padding: pxArrayToRem([8, 38]),
            paddingRight: pxToRem(34, 1),
            marginLeft: pxToRem(2, 1),
            letterSpacing: pxToRem(0.2, 1),

            [`& span`]: {
                marginLeft: pxToRem(2, 1),
            },

            [`& .${svgIconClassName}`]: {
                marginTop: pxToRem(3, 1),
                marginLeft: pxToRem(5, 1),
            },
        },
    },
});

export const SliderButtonHidden = () => ({
    display: 'none',
});
